
import ENDPOINTS from '@/api/endpoints/bingoManager-core/endpoints.js';
import { service } from '@/api/clients/bingoManager-core/baseClient.js';

export default {
  getScheduleInRange(startDate, endDate) {
    return service.get(ENDPOINTS.REPORTING.NEW_SESSION_REQUEST, {
      params: {
        startDate: startDate,
        endDate: endDate,
      },
    });
  },
  getReportingByScheduleId(scheduleId, date) {
  
    console.log('getReportingByScheduleId - scheduleId:', scheduleId, 'date:', date);

    if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) {
      throw new Error('Invalid date format provided');
    }

    return service.get(ENDPOINTS.REPORTING.GET_SESSION_REPORTING, {
      params: {
        scheduleId: scheduleId,
        date: date, 
      },
    });
  },
};